import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import Icon from '../../common/Icon';

const NavigationHiddenContentHelper = () => {
  return (
    <div className="NavigationHiddenContentHelper">
      <Container className="NavigationHiddenContent__helper-container">
        <Row>
          <Col xs="12">
            <Icon
              name="angle-down"
              className="NavigationHiddenContentHelper__icon"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NavigationHiddenContentHelper;
